import React from "react";

export default function HtmlDisplay({children, component = "span", className}: any) {
    return React.createElement(component, {
        dangerouslySetInnerHTML: {__html: children},
        className: `${className} html-display`,
    });
}